import React from 'react'
import ServiceCard from './Cards/ServiceCard'
import './style/Service.css'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons'
import { faObjectUngroup } from '@fortawesome/free-regular-svg-icons'
import { faCode } from '@fortawesome/free-solid-svg-icons'
import { faChartPie } from '@fortawesome/free-solid-svg-icons'
import { faTv } from '@fortawesome/free-solid-svg-icons'
import { faPaintBrush } from '@fortawesome/free-solid-svg-icons'

function Service() {
    return (
        <div className="service" id="service">
            <span>Service</span>
            <h2>Service Provide</h2>
            <div className="services">
                <ServiceCard title="Graphic Design" icon={faPaintBrush}/>
                <ServiceCard title="Web Design" icon={faTv}/>
                <ServiceCard title="Ui/Ux Design" icon={faObjectUngroup}/>
                <ServiceCard title="Html/Css" icon={faCode}/>
                <ServiceCard title="Busniess Analysis" icon={faChartPie}/>
                <ServiceCard title="Seo Marketing" icon={faBullhorn}/>
            </div>
        </div>
    )
}

export default Service
